<script setup>
import { Head, Link, useForm } from "@inertiajs/vue3";

import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";
import VTitleWithBackLink from "@/Shared/VTitleWithBackLink.vue";
import VAlert from "@/Shared/VAlert.vue";
import VDevider from "@/Shared/VDevider.vue";

import VTab from "@/Pages/PublicPage/Survey/_partials/VTab.vue";
import VFormOutbound from "@/Pages/PublicPage/Survey/_partials/VFormOutbound.vue";
import VHeaderButtonInfo from "@/Shared/HeaderButton/VButtonInfo.vue";
import VShowDeparting from "../PublicPage/Survey/_partials/VShowDeparting.vue";
import { listTabDepartingVisitor, listTabSabahOutbound } from "./tabs.config";
import { ref, watch } from "vue";
import VShowOutbound from "../PublicPage/Survey/_partials/VShowOutbound.vue";
import VButton from "@/Shared/Buttons/VButton.vue";

const props = defineProps({
    title: String,
    additional: Object,
});

const {
    filters,
    urlShow,
    urlIndex,
    urlTranslate,
    urlToggleOri,
    answers,
    surveyFields,
    survey,
    isShowOri,
    entries,
} = props.additional;

const breadcrumbs = [
    {
        url: urlIndex,
        label: "Response List",
    },
    {
        url: "#",
        label: "View",
    },
];

const TYPE_SURVEY_DEPARTING = "departing-visitor-survey";
const TYPE_SURVEY_OUTBOUND = "sabah-outbound-survey";

const tabs =
    survey.code == TYPE_SURVEY_DEPARTING
        ? listTabDepartingVisitor
        : listTabSabahOutbound;

const currentTabIndex = ref(0);
const currentTab = ref(tabs[0]);
const currentTabKey = ref(currentTab.value.key);

const form = useForm({});

tabs.map((item) => {
    item.status = 1;
    return item;
});

watch(currentTabKey, (newValue) => {
    currentTab.value = tabs.find((item) => item.key == newValue);
});

const clickTranslate = () => {
    form.post(urlTranslate, {
        preserveScroll: true,
    });
};

const clickToogleOri = () => {
    form.get(urlToggleOri, {
        preserveScroll: true,
    });
};
</script>

<template>
    <Head>
        <title>{{ title }}</title>
    </Head>

    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />

        <div class="card">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <VTitleWithBackLink
                        :href="urlIndex"
                        :filters="filters ?? {}"
                    >
                        Show Survey Entries - {{ survey.name }}
                    </VTitleWithBackLink>
                    <div class="btn-wrapper">
                        <VButton
                            v-if="
                                additional.entries?.is_translated != 1 &&
                                survey.code == TYPE_SURVEY_DEPARTING
                            "
                            type="button"
                            btnStyle="btn-sm btn-warning me-1"
                            @onClick="clickTranslate"
                        >
                            Translate
                        </VButton>
                        <VButton
                            type="button"
                            btnStyle="btn-sm btn-light"
                            @onClick="clickToogleOri"
                            v-if="survey.code == TYPE_SURVEY_DEPARTING"
                        >
                            {{
                                additional.isShowOri == 0
                                    ? "Show Original"
                                    : "Show Translated"
                            }}
                        </VButton>
                    </div>
                </div>
                <VDevider class="mb-4" />
                <VAlert />

                <div class="row">
                    <div class="col-12 col-md-3">
                        <VTab :tabs="tabs" v-model:value="currentTabKey"></VTab>
                    </div>
                    <div class="col-12 col-md-9">
                        <div class="card">
                            <div class="card-body">
                                <component
                                    :is="
                                        survey.code == TYPE_SURVEY_DEPARTING
                                            ? VShowDeparting
                                            : VShowOutbound
                                    "
                                    :tab="currentTab"
                                    :survey="survey"
                                    :answers="answers"
                                    :surveyFields="surveyFields"
                                    @onNext="handleOnNext"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
